var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "addBox",
      attrs: {
        title: (_vm.isEdit ? "编辑" : "添加") + "跟进提醒",
        top: "25vh",
        "append-to-body": true,
        visible: _vm.dialogVisible,
        width: "500px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "line" }),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "from",
          attrs: { model: _vm.form, rules: _vm.rules },
        },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: " 提醒时间：",
                "label-width": "100px",
                prop: "time",
              },
            },
            [
              _c("el-date-picker", {
                staticClass: "picker-time",
                attrs: {
                  type: "datetime",
                  "default-time": "09:00:00",
                  placeholder: "请选择日期",
                },
                model: {
                  value: _vm.form.time,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "time", $$v)
                  },
                  expression: "form.time",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: {
                label: " 提醒内容：",
                "label-width": "100px",
                prop: "content",
              },
            },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  maxlength: "200",
                  placeholder: "请输入提醒内容",
                },
                model: {
                  value: _vm.form.content,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "content", $$v)
                  },
                  expression: "form.content",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "dialog-footer" },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn",
                  attrs: { size: "small" },
                  on: { click: _vm.handleClose },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "btn",
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.handleConfirm },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }